let architectEventsApi = {
    async get(token, companyId, params = {}) {
        let response = await window.axios.get('/api/architect-events', {
            params: {
                api_token: token,
                company_logged: companyId,
                ...params
            }
        });
        return response.data;
    },
    async find(id, token, companyId) {
        let response = await window.axios.get('/api/architect-events/' + id, {
            params: {
                api_token: token,
                company_logged: companyId
            }
        });
        return response.data;
    },
    async create(event, token, companyId) {
        let response = await window.axios.post('/api/architect-events', event, {
            params: {
                api_token: token,
                company_logged: companyId
            }
        });
        return response.data;
    },
    async update(event, token, companyId) {
        let response = await window.axios.put('/api/architect-events/' + event.id, event, {
            params: {
                api_token: token,
                company_logged: companyId
            }
        });
        return response.data;
    },
    async delete(event, token, companyId) {
        let response = await window.axios.delete('/api/architect-events/' + event.id, {
            params: {
                api_token: token,
                company_logged: companyId
            }
        });
        return !!response.data.success;
    },
    async confirmParticipant(eventId, architectId, token, companyId) {
        let response = await window.axios.put(
            '/api/architect-events/' + eventId + '/participants/' + architectId + '/confirm',
            {},
            {
                params: {
                    api_token: token,
                    company_logged: companyId
                }
            }
        );
        return !!response.data.success;
    }
};

export default architectEventsApi;
